export enum StorageKeys {
  BEARER_TOKEN = 'bearer-token',
  USER = 'logged-in-user',
  USER_DETAILS = 'logged-in-user-details',
  ROUTE = 'current-route',
  EQUIPCONFIG ='equip-config',
  PLANTCONFIG ='plant-config',
  TEMPPLANTDATA ='temp-plant-data'
}